/* MARMOT F2 — чиста логика на попъпа за доставка (без DOM).

   Изнесена отделно, за да е тестима с `node --test` без браузър и за да
   се преизползва от marmot-delivery-popup.js в браузъра (UMD: закача се на
   window.MarmotF2Logic, а в Node се експортва през module.exports).

   Тук НЯМА достъп до document/window — само пресмятания и правила. */
(function (root, factory) {
  var api = factory();
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  else root.MarmotF2Logic = api;
})(typeof self !== 'undefined' ? self : this, function () {
  'use strict';

  var BGN_RATE = 1.95583; // фиксиран курс EUR→BGN

  /* Валута — огледало на snippets/marmot-price.liquid:
     „15,34 € (30.00 лв)" — евро със знак отзад и десетична запетая,
     левовете в скоби с точка, integer аритметика в стотинки (без float дрейф). */
  function money(cents, dual) {
    var c = Math.round(cents || 0);
    var eu = Math.floor(c / 100);
    var ec = c % 100;
    var eur = eu + ',' + (ec < 10 ? '0' : '') + ec + ' €';
    if (dual === false) return eur;
    var lv = Math.floor((c * 195583 + 50000) / 100000); // лв в стотинки
    var lu = Math.floor(lv / 100);
    var lc = lv % 100;
    return eur + ' (' + lu + '.' + (lc < 10 ? '0' : '') + lc + ' лв)';
  }

  function methodKey(courier, service) {
    return courier && service ? courier + ':' + service : null;
  }

  /* §4.1 — смяна на метода на доставка.
     Ако методът се смени (различен куриер ИЛИ различна услуга), избраният офис
     се нулира, а всеки започнат draft опит се обезсилва (нов idempotency ключ →
     null, за да се генерира наново). Така Speedy office id не може да се закачи
     за Econt пратка, нито стар офис да пътува към новосъздадена поръчка.

     prev: { courier, service, officeId, officeLabel, officeType, idempotencyKey }
     method: { courier, service }
     Връща новото състояние + officeReset (дали офисът е нулиран). */
  function applyMethodChange(prev, method) {
    prev = prev || {};
    var prevKey = methodKey(prev.courier, prev.service);
    // „Нулиране" има само ако е ИМАЛО предишен метод и той се сменя. Първият
    // избор (от нищо) не е нулиране — няма какво да се обезсили.
    var changed = !!prevKey && prevKey !== methodKey(method.courier, method.service);
    var next = {
      courier: method.courier,
      service: method.service,
      officeId: prev.officeId || null,
      officeLabel: prev.officeLabel || null,
      officeType: prev.officeType || null,
      idempotencyKey: prev.idempotencyKey || null,
      officeReset: false,
      needsOffice: method.service === 'office',
      needsAddress: method.service === 'address'
    };
    if (changed) {
      next.officeId = null;
      next.officeLabel = null;
      next.officeType = null;
      next.idempotencyKey = null; // обезсилва започнат draft опит
      next.officeReset = true;
    }
    return next;
  }

  function freeThresholdCents(cfg) {
    return Math.round(((cfg && cfg.freeShippingThresholdEur) || 0) * 100);
  }

  /* Безплатна доставка: над прага, ИЛИ точно на прага — границата е
     ВКЛЮЧВАЩА (решение на Николай, 28.07.2026): количка точно 30,00 € получава
     безплатна доставка. Само изричното freeShippingInclusive === false връща
     старото строго „над прага". Точно огледало на isFreeShipping в
     shopifyCheckoutService.ts; двете страни смятат върху едно и също число —
     сумата на final_line_price по редовете на количката. */
  function isFreeShipping(subtotalCents, cfg) {
    if (!cfg || !cfg.freeShippingThresholdEur) return false;
    var t = freeThresholdCents(cfg);
    if (subtotalCents > t) return true;
    return subtotalCents === t && cfg.freeShippingInclusive !== false;
  }

  /* Цена на доставката в стотинки: null докато няма избран метод, 0 при
     безплатна, иначе цената на метода. */
  function shippingCents(subtotalCents, methodPriceEur, cfg) {
    if (methodPriceEur == null) return null;
    if (isFreeShipping(subtotalCents, cfg)) return 0;
    return Math.round(methodPriceEur * 100);
  }

  function computeTotals(opts) {
    var subtotal = opts.subtotalCents;
    if (subtotal == null) {
      return { subtotalCents: null, shippingCents: null, totalCents: null, isFree: false };
    }
    var ship = shippingCents(subtotal, opts.methodPriceEur, opts.cfg);
    return {
      subtotalCents: subtotal,
      shippingCents: ship,
      totalCents: subtotal + (ship || 0),
      isFree: isFreeShipping(subtotal, opts.cfg)
    };
  }

  /* Прогрес „още X до безплатна доставка" — видим от стъпка 1, за да стигне
     информацията до клиента, докато още може да добави книга. */
  function freeShipProgress(subtotalCents, cfg) {
    if (!cfg || !cfg.freeShippingThresholdEur || subtotalCents == null) {
      return { show: false, remainingCents: 0, percent: 0, isFree: false };
    }
    var t = freeThresholdCents(cfg);
    if (isFreeShipping(subtotalCents, cfg)) {
      return { show: false, remainingCents: 0, percent: 100, isFree: true };
    }
    var remaining = t - subtotalCents;
    var percent = t > 0 ? Math.max(0, Math.min(100, Math.round((subtotalCents / t) * 100))) : 0;
    // При включваща граница точно на прага излиза по-горе като безплатно. Тук
    // remaining може да е 0 само при изричното freeShippingInclusive === false;
    // предпазителят show: remaining > 0 пази от подвеждащото „0 € остават“.
    return { show: remaining > 0, remainingCents: Math.max(0, remaining), percent: percent, isFree: false };
  }

  /* Може ли CTA-то да върви напред от текущата стъпка.
     Стъпка 1 винаги пуска напред; стъпка 2 иска избран метод; стъпка 3 предава
     на реалния чекаут. (Валидацията на полетата е отделна, при опит за напред.) */
  function canAdvance(step, methodSelected) {
    if (step >= 3) return true;
    if (step === 1) return true;
    return !!methodSelected; // step === 2
  }

  function ctaLabel(step, methodSelected) {
    if (step === 1) return 'Метод на доставка'; // Метод на доставка
    if (step === 2) return methodSelected
      ? 'Към последната стъпка' // Към последната стъпка
      : 'Избери начин на доставка'; // Избери начин на доставка
    return 'Продължи към плащане'; // Продължи към плащане
  }

  function stepFlags(step) {
    return {
      s1open: step === 1, s1done: step > 1,
      s2open: step === 2, s2done: step > 2,
      s3open: step === 3,
      canBack: step > 1
    };
  }

  /* Рейлът позволява връщане назад, но не скок напред: целева стъпка n е
     достъпна само ако n <= текущата. */
  function railTarget(current, n) {
    return n <= current ? n : current;
  }

  /* Отделни градове (град + пощенски код) от списък офиси — за флоу „първо град,
     после офис". Пощенският код различава дублиращи се имена на населени места. */
  function distinctCities(offices) {
    var seen = {}, out = [];
    for (var i = 0; i < (offices || []).length; i++) {
      var o = offices[i] || {};
      if (!o.city) continue;
      var key = o.city + '|' + (o.zip || '');
      if (!seen[key]) { seen[key] = 1; out.push({ city: o.city, zip: o.zip || '' }); }
    }
    return out;
  }

  /* Български телефон → +359XXXXXXXXX или null. Огледало на popup валидацията. */
  function normalizePhone(value) {
    var compact = (value || '').trim().replace(/[\s().-]/g, '');
    var n = compact;
    if (compact.indexOf('00359') === 0) n = '+359' + compact.slice(5);
    else if (compact.charAt(0) === '0') n = '+359' + compact.slice(1);
    return /^\+359\d{9}$/.test(n) ? n : null;
  }

  /* Промо кодът не се валидира в попъпа. Бележката описва само записването му
     и изрично оставя прилагането условно до стъпката за плащане. */
  function promoNote(rawCode) {
    var code = (rawCode || '').trim().toUpperCase();
    if (!code) return null;
    return {
      code: code,
      show: true,
      text: 'Кодът „' + code + '“ е записан и ще бъде приложен при плащането, ако е валиден.'
    };
  }

  return {
    BGN_RATE: BGN_RATE,
    money: money,
    methodKey: methodKey,
    applyMethodChange: applyMethodChange,
    isFreeShipping: isFreeShipping,
    shippingCents: shippingCents,
    computeTotals: computeTotals,
    freeShipProgress: freeShipProgress,
    canAdvance: canAdvance,
    ctaLabel: ctaLabel,
    stepFlags: stepFlags,
    railTarget: railTarget,
    distinctCities: distinctCities,
    normalizePhone: normalizePhone,
    promoNote: promoNote
  };
});
